/* global $:false */

import utils from '../cob.utils.js';
import AuthM from "../model/cob.authm.js";
import tmpl_auth from '../templates/auth-login.dot';

// "Module" responsible for showing the login UI and authenticating the user.
var auth = function(core) {

    var _$container = $('#' + core.getAppInstanceId()),
        _formPresenter = new AuthFormPresenter(core, _$container);

    return {
        init: async function() {
            await _formPresenter.init();
            _formPresenter.resume();
        },
        resume: function() {
            window.console.log("Resuming login");

            _formPresenter.resume();
        },
        pause: function() {
            window.console.log("Pausing login");

            _formPresenter.pause();
        },
        destroy: _formPresenter.destroy
    };
};

var AuthModel = function(core) {
    this._core = core;
    this.validLogin = false;
};

// loginInfo: must be an object with keys username and password
AuthModel.prototype.validateLogin = function(loginInfo) {
    var _this = this;

    this._core.login(loginInfo, {
        success: function() {
            _this.validLogin = true;
        },
        error: function(req) {
            _this.validLogin = false;
            window.console.log("login:error: " + req.status + " : " + req.statusText + ":" + req.responseText);
        },
        complete: function() {
            _this._core.publish("authentication-response-received");
        }
    });
};

// container: the HTML selector for the enclosing element
//
// callbacks:
//
// * `loginSubmit`: called when the user tries to sumbit the login form
// * `authmLogin`: called when the user requests auth using AuthM
// opts:
// * `idps`: an array of Idp
var AuthView = function(core, $container, callbacks, opts) {
    var _appInfo = core.getAppInfoModel();

    var template = tmpl_auth;
    var _templateOverride = core.getSettings().loginTemplate;
    if (_templateOverride !== undefined) {
        template = core.compile("cob-auth-tmpl", _templateOverride)
    }

    var _$container = $(template({appName: _appInfo.appId, logo: _appInfo.appLogo, idps: opts?.idps || []})),
        _$loginForm = $(".login-form", _$container),
        _$usernameField = $("#username", _$container),
        _$passwordField = $("#password", _$container),
        _$loginBtn = $("#login-btn", _$container),
        _$authmLoginBtn = $(".js-authm-login", _$container),
        _$disclaimer = $('.disclaimer', _$container);

    var _onSubmit = function(e) {
        //Deactivate future attempts until the current is completed
        _$loginBtn.attr('disabled', true);

        //we'll "submit" the form manually
        e.preventDefault();

        //we use the format expected by `AuthModel.validateLogin`
        callbacks.loginSubmit({
            username: _$usernameField.val().trim(),
            password: _$passwordField.val().trim()
        });
    };

    var _ieKeypressHack = function(e) {
        if (e.which === 13) _onSubmit(e);
    };

    return {
        init: function() {
            //Since we changed the login form to a template we need to translate and append it to its container
            core.translate("cob.app", _$container, true);
            $container.prepend(_$container);

            _$loginForm.on('submit', _onSubmit);
            _$authmLoginBtn.on('click', (ev) => {
                callbacks.authmLogin($(ev.target).data("sso-uri"))
            });

            $("input", _$loginForm).on('keypress', _ieKeypressHack);
        },
        destroy: function() {
            _$loginForm.off('submit', _onSubmit);
            $("input", _$loginForm).off('keypress', _ieKeypressHack);
            _$container.remove()
        },
        show: function() {
            _$container.show();
            _$loginForm.show();
        },

        //show the unsupported browser disclaimer
        showDisclaimer: function() {
            _$disclaimer.show();
        },

        //between the _user_ and _password_ fields select the first that's empty, to help the user be faster
        selectFirstEmptyField: function() {
            //_$usernameField.val() returns an empty string on some browsers while others return undefined
            if (_$usernameField.val() === undefined || _$usernameField.val().length === 0) {
                _$usernameField.focus();
            } else {
                _$passwordField.focus();
            }
        },

        //shake the form, to indicate a login error
        shake: function() {
            _$loginForm.effect('shake', {times: 3, distance: 5}, 20);
        },
        clearUsername: function() {
            _$usernameField.val('');
        },
        clearPassword: function() {
            _$passwordField.val('');
        },
        fadeOut: function(time, callback) {
            _$container.hide("fade", {}, time, callback);
        },
        hide: function() {
            _$container.hide();
        },
        activateForm: function() {
            _$loginBtn.removeAttr('disabled');
        }
    };
};

// callbacks:
//
// * `sucessfullLogin`: called when the user logs in
var AuthFormPresenter = function(core, $container) {

    var model = new AuthModel(core);

    var _areAllFieldsFilled = function(data) {
        return data.username && data.password;
    };

    let _view;

    var _onAuthenticationResponse = function() {
        if (model.validLogin) {
            _view.fadeOut(300, function() {
                core.publish("app:security:user-changed");
            });

        } else {
            _view.shake();
            utils.delayed(function() {
                _view.clearPassword();
                _view.selectFirstEmptyField();
            }, 300);
            _view.activateForm();
        }
    };

    var _init = async function() {
        core.subscribe("authentication-response-received", _onAuthenticationResponse);

        await AuthM.loadAllIdps()
            .then((idps) => {
                _view = new AuthView(
                    core,
                    $container,
                    {
                        loginSubmit: function(loginData) {
                            if (_areAllFieldsFilled(loginData)) {
                                model.validateLogin(loginData);

                            } else {
                                _view.shake();
                                _view.activateForm();
                                _view.selectFirstEmptyField();
                            }
                        },
                        authmLogin: function(ssoUri) {
                            let redirectTo = `?redirectTo=${window.location.pathname}`

                            let currentHash = window.location.hash;
                            if (currentHash.indexOf("/login") === -1) {
                                if (currentHash.indexOf("?_=") !== -1) {
                                    currentHash = currentHash.substring(0, currentHash.indexOf("?_="))
                                }

                                redirectTo += encodeURIComponent(currentHash);
                            }

                            window.location.href = ssoUri + redirectTo;
                        }
                    },
                    {idps}
                );

                _view.init();

                //if the browser is unsupported, show a little disclaimer, but let the user proceed at their own risk
                if (!core.isSupportedBrowser()) {
                    _view.showDisclaimer();
                }
            })
    };

    var _resume = function() {
        _view.show();
        _view.selectFirstEmptyField();
        _view.activateForm();
    };

    var _pause = function() {
        _view.hide();
        _view.clearUsername();
        _view.clearPassword();
    };

    var _destroy = function() {
        core.unsubscribe("authentication-response-received", _onAuthenticationResponse);

        _view.destroy();
    };

    return {
        init: _init,
        resume: _resume,
        pause: _pause,
        destroy: _destroy
    };
};

export default auth;
